
import _ from '../lib/helper';
import cls from '../lib/class';
import instances from './instances';
import updateGeometry from './update-geometry';

import nativeScrollHandler from './handler/native-scroll';

import clickRail from './handler/click-rail';
import dragScrollbar from './handler/drag-scrollbar';
import keyboard from './handler/keyboard';
import wheel from './handler/mouse-wheel';
import touch from './handler/touch';
import selection from './handler/selection';


// Handlers
var handlers = {
  'click-rail': clickRail,
  'drag-scrollbar': dragScrollbar,
  'keyboard': keyboard,
  'wheel': wheel,
  'touch': touch,
  'selection': selection
};

export default function (element, userSettings) {
  userSettings = typeof userSettings === 'object' ? userSettings : {};

  cls.add(element, 'ps-container');

  // Create a plugin instance.
  var i = instances.add(element);

  i.settings = _.extend(i.settings, userSettings);
  cls.add(element, 'ps-theme-' + i.settings.theme);

  i.settings.handlers.forEach(function (handlerName) {
    handlers[handlerName](element);
  });

  // nativeScrollHandler(element);

  updateGeometry(element);
};
